// extracted by mini-css-extract-plugin
export default {"list":"list_list__mkFP0","dot":"list_dot__Ye-YM","levels":"list_levels__YvhIy","reversed":"list_reversed__gAJhR","level":"list_level__P-OB4"};